export {
  BrowserRouter,
  HashRouter,
  MemoryRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
  useNavigate,
  useLocation,
  useMatch,
  useSearchParams,
  useRoutes,
  matchPath,
  createBrowserRouter,
  createMemoryRouter,
  RouterProvider,
  createSearchParams,
  generatePath,
  resolvePath,
  useBlocker,
  useInRouterContext,
  useNavigationType,
  useResolvedPath,
  useHref
} from "react-router-dom-original";

export {
  CompatLink as Link,
  CompatNavLink as NavLink,
  Switch,
  Redirect,
  useHistory,
  useParams,
  useRouteMatch,
  withRouter
} from "./v5Compat";
